export const FAQRoute: string = "frequently-asked-questions";